export default __webpack_public_path__ + "static/media/Spreadsheet2.96f00c12.svg";